import { useCallback, useEffect, useState } from "react"
import { statusAssets } from "../../../config/constants/statusAssetsConstants";

export const useAssetsByFinalCustomer = ({ assetTypeId, idFinalCustomer, getData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [assets, setAssets] = useState({ assets: [] })

  const getAssets = useCallback(
    async (page = 1, search = "", status = statusAssets.active.id) => {
      setIsLoading(true)
      try {
        const data = await getData({ page, search, assetTypeId, idFinalCustomer, status })
        setAssets(data)
      } catch (error) {
        console.error(error)
        setAssets({ assets: [] })
      } finally {
        setIsLoading(false)
      }
    }, [getData, assetTypeId, idFinalCustomer]
  )

  const reloadAssets = useCallback(() => {
    getAssets();
  }, [getAssets, assetTypeId, idFinalCustomer,]);

  useEffect(() => {
    reloadAssets()
  }, [getAssets, assetTypeId, idFinalCustomer])


  return {
    isLoading,
    assets,
    reloadAssets,
  }
}